import { render, staticRenderFns } from "./ActionGlobalView.vue?vue&type=template&id=603abcdc&scoped=true&"
import script from "./ActionGlobalView.vue?vue&type=script&lang=js&"
export * from "./ActionGlobalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603abcdc",
  null
  
)

export default component.exports